export default class CategoryTracker {

    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.events = window.__pt.fn.analytics.events;
        this.hotel = window.__pt.hotel || {};
    }

    sendEventTracker(category, label) {
        const data = {
            event: this.events.gtmEvent,
            eventAction: `${this.hotel.hotelId}`,
            eventCategory: category,
            eventLabel: label,
            eventName: this.events.gtmEvent
        }

        this.analytics.set(this.events.gtmEvent, data);
    }

}